import { Tag } from '@/types';
import { useLocalizedRoute } from '@/hooks';
import { UI } from '@/Components/UI';

type TagsListProps = {
    tags: Tag[];
};

export const TagsList = ({ tags }: TagsListProps) => {
    const { localizedRoute } = useLocalizedRoute();

    return (
        <div className={'flex flex-row flex-wrap gap-2'}>
            {tags.map((tag, index) => (
                <UI.Button.Link
                    key={index}
                    buttonStyle={'tonal'}
                    className={'px-2 py-1'}
                    href={localizedRoute('search.index', { tags: [tag.id] })}>
                    <span className={'opacity-50'}>#</span>
                    &nbsp;
                    {tag.name}
                </UI.Button.Link>
            ))}
        </div>
    );
};
